// extracted by mini-css-extract-plugin
export default {"root":"styles_root__JjL1x","urlContainer":"styles_urlContainer__sGSC2","newItem":"styles_newItem__kDxwm","url":"styles_url__jjCud","delete":"styles_delete__9wf8-"};